import * as types from "./types";
import { combineReducers } from "redux";

function searchListaColegios(state = [], action) {
  switch (action.type) {
    case types.OBTENER_BUSQUEDA_INSCRIPCIONES_COLEGIO:
      return action.payload;

    case types.LIMPIAR_BUSQUEDA_INSCRIPCIONES_COLEGIO:
      return [];

    default:
      return state;
  }
}

function inscribirEnColegio(state = null, action) {
  switch (action.type) {
    case types.INSCRIBIR_EN_COLEGIO:
      return action.payload;

    case types.RESET_INSCRIBIR_EN_COLEGIO:
      return null;

    default:
      return state;
  }
}

function detalleColegio(state = {}, action) {
  switch (action.type) {
    case types.OBTENER_DETALLE_COLEGIO:
      return action.payload;
    case types.LIMPIAR_DETALLE_COLEGIO:
      return {};
    default:
      return state;
  }
}

function dataSaved(
  state = { status: false, message: "", resguardo: null },
  action
) {
  switch (action.type) {
    case types.DATA_SAVED:
      return action.payload;
    case types.RESET_DATA_SAVED:
      return { status: false, message: "", resguardo: null };
    default:
      return state;
  }
}

const reducer = combineReducers({
  searchListaColegios,
  inscribirEnColegio,
  detalleColegio,
  dataSaved
});

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/inscripciones/reducers.js